export const TERMINOLOGY_LEVEL_OPTIONS = [
  { value: 'simple', label: 'Simple' },
  { value: 'explained', label: 'Explained' },
  { value: 'technical', label: 'Technical' },
] as const

export const TOPIC_OPTIONS = [
  'Career',
  'Marriage',
  'Health',
  'Finance',
  'Children',
  'Relocation',
  'Spiritual growth',
] as const

export const RELATIONSHIP_OPTIONS = [
  { value: 'self', label: 'Self' },
  { value: 'spouse', label: 'Spouse' },
  { value: 'child', label: 'Child' },
  { value: 'father', label: 'Father' },
  { value: 'mother', label: 'Mother' },
  { value: 'brother', label: 'Brother' },
  { value: 'sister', label: 'Sister' },
  { value: 'relative', label: 'Relative' },
  { value: 'friend', label: 'Friend' },
  { value: 'prospective_partner', label: 'Prospective partner' },
  { value: 'other', label: 'Other' },
] as const

export const GENDER_OPTIONS = [
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
  { value: 'O', label: 'Other' },
] as const

export const BIRTH_TIME_TIER_OPTIONS = [
  { value: 0, label: 'Exact record (± 3 min)' },
  { value: 1, label: 'Reliable memory (± 5 min)' },
  { value: 2, label: 'Approximate recall (± 15 min)' },
  { value: 3, label: 'Rough estimate (± 60 min)' },
  { value: 4, label: 'Exact time only (0 min window)' },
] as const

export const SOCKET_BASE_DELAY_MS = 1000
export const SOCKET_DELAY_MULTIPLIER = 2
export const SOCKET_MAX_DELAY_MS = 30000
export const SOCKET_MAX_FAILURES = 10
export const SOCKET_JITTER_MS = 1000

export const APP_ROUTES = {
  login: '/auth',
  chatDraft: '/chat/new',
  billing: '/billing',
  settings: '/settings',
  newSubject: '/subjects/new',
  btr: (subjectId: string) => `/btr/${subjectId}`,
} as const

export const DEFAULT_CHAT_PROMPTS = [
  'What should I focus on over the next three months?',
  'What themes stand out in my current dasha period?',
  'How should I think about career timing this year?',
]
